<template>
  <div class="card-container">
    <common-top-form
      ref="commonTopForm"
      selectShowPower="/copymerchantInfo/select"
      :show="false"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      :showDownloadPower="true"
      @down="down"
      showDownloadPowerType="warning"
      :clickShow="true"
      @click="click"
      clickShowType="warning"
      :implementIssuedShow="true"
      @implementIssuedcz="implementIssuedcz(1, 1)"
      implementIssuedType="warning"
      :batchShow="true"
      @batchLookDialog="implementIssuedcz(1, 2)"
      batchShowType="warning"
    >
      <el-form-item label="机具sn">
        <el-input v-model="formModel.sn" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="商户号">
        <el-input v-model="formModel.shh" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="用户Id">
        <el-input v-model="formModel.userld" placeholder="请输入"></el-input>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
       <el-table-column
        prop="id"
        label="id"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="userld"
        label="用户Id"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="用户昵称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="nickName"
        label="实名姓名"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="shh"
        label="商户号"
        min-width="220"
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="sn"
        label="机具sn"
        min-width="220"
        :formatter="formatterTableData"
      >
      </el-table-column>
      <el-table-column
        prop="time"
        label="绑定时间"
        min-width="220"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <!-- <el-table-column
        v-if="hasPerm('/copymerchantInfo/zhuxaio')"
        label="操作"
        min-width="300"
        fixed="right"
      >
        <template slot-scope="scope" style="display: flex">
          <el-button type="text" @click="openAddDialog(1, scope.row)"
            >修改
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
                      >注销
                    </el-button>
          <span style="color: #e6a23c">|</span>
          <el-button type="text" @click="manage(scope.row)"
            >终端管理
          </el-button>
          <el-button type="text" @click="feilv(scope.row)">费率</el-button>
          <el-button type="text" @click="openAddDialog(2, scope.row)"
            >划拨商户
          </el-button>
        </template>
      </el-table-column> -->
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="type == 1 ? '修改' : '划拨商户'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @success="dialogSuccess"
      @close="dialogClose"
      class="note"
    >
      <div v-if="type == 1">
        <el-form-item label-width="93px" label="激活次数" prop="actNum">
          <el-input-number
            style="width: 261.75px"
            v-model="dialogModel.actNum"
            :min="0"
            :max="999999999"
            :step="0"
            :precision="0"
            :controls="false"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label-width="93px" label="SN号" prop="terminalId">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.terminalId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="93px" label="商户名称" prop="merName">
          <el-input
            type="text"
            maxlength="20"
            v-model="dialogModel.merName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="93px" label="商户手机号" prop="merPhone">
          <el-input
            type="text"
            maxlength="11"
            show-word-limit
            v-model="dialogModel.merPhone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="93px" label="真实姓名" prop="realName">
          <el-input
            type="text"
            maxlength="11"
            v-model="dialogModel.realName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label-width="93px" label="身份证号" prop="idCardNo">
          <el-input
            type="text"
            v-model="dialogModel.idCardNo"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </div>
      <div v-if="type == 2">
        <el-form-item label="代理商ID" prop="userId" label-width="110px">
          <el-input
            type="text"
            v-model="dialogModel.userId"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <div class="flex-row vertical-center mem-name">
          <p>代理商名称：</p>
          <p v-if="memName.phoneNumber">
            {{
              memName.realName ||
              memName.nickName ||
              "用户" + memName.phoneNumber
            }}
          </p>
        </div>
      </div>
    </form-dialog>
    <el-dialog
      :title="exportType == 2 ? '商户交易量导出' : '睡眠商户导出'"
      :visible.sync="centerDialogVisible"
      width="450px"
      center
      @close="startDateClose"
    >
      <div class="startDate">
        <el-form
          :model="form"
          :rules="formRules"
          ref="myForm"
          class="demo-form"
        >
          <el-form-item label="时间" prop="startDate" v-if="exportType == 1">
            <el-date-picker
              v-model="form.startDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="时间" prop="date" v-else>
            <el-date-picker
              v-model="form.date"
              type="month"
              value-format="yyyy-MM"
              placeholder="选择月份"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="implementIssuedcz(2, exportType)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";

import OrganService from "service/OrganService";
import MerchantManage from "service/MerchantManage";
import StatisticsService from "service/StatisticsService";
import FinanceService from "service/FinanceService";
import MonthNum from "service/constant/MonthNum";
import DayNum from "service/constant/DayNum";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters, mapActions } from "vuex";
import StorageService from "store/interfaces";
import activity from "service/Ainstitution";
export default {
  name: "copymerchantInfo",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    return {
      centerDialogVisible: false,
      form: {
        startDate: "",
        date: "",
      },
      formRules: {
        startDate: [
          {
            required: true,
            message: "请选择",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      time: [],
      levelNameList: [],
      formModel: {
        realName: "",
        merName: "",
        merNo: "",
        merPhone: "",
        agentNo: "",
        terminalId: "",
        gender: "",
        month: "",
        day: "",
        tatSimpleId: "",
      },
      typeTwo: [{ tatName: "全部", id: "" }],
      tableData: [],
      memName: {},
      itemId: "",
      dialogModel: {
        actNum: undefined,
        merName: "",
        terminalId: "",
        merPhone: "",
        realName: "",
        idCardNo: "",

        userId: "",
      },
      dialogRules: {
        // actNum: [
        //   {
        //     required: true,
        //     message: "请输入",
        //   },
        // ],
        // merName: [
        //   {
        //     required: true,
        //     message: "请输入",
        //   },
        // ],
        // merPhone: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       if (!value) {
        //         callback(new Error("请输入"));
        //       } else if (
        //         value.split(",").some((item) => !Regs.phone.test(item))
        //       ) {
        //         callback(new Error("请输入正确的11位手机号码"));
        //       } else {
        //         return callback();
        //       }
        //     },
        //   },
        // ],
        // realName: [
        //   {
        //     required: true,
        //     message: "请输入",
        //   },
        // ],
        // idCardNo: [
        //   {
        //     required: true,
        //     message: "请输入",
        //   },
        // ],

        userId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入"));
              } else if (!/^\d+$/.test(value)) {
                callback(new Error("请输入纯数字"));
              } else {
                this.getRealNameByPhone(value, (res) => {
                  if (res.respCode == "0000") {
                    this.memName = res.contents;
                    this.memId = res.contents.id;
                    if (!this.memName.id) {
                      callback(new Error("查询不到此用户"));
                      this.memName = "";
                      this.memId = "";
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("查询不到此用户"));
                    this.memName = "";
                    this.memId = "";
                  }
                });
              }
            },
          },
        ],
      },
      chnCode: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      isEvaluate: [
        {
          dictKey: "",
          dictValue: "全部",
        },
        {
          dictKey: "0",
          dictValue: "否",
        },
        {
          dictKey: "1",
          dictValue: "是",
        },
      ],
      weComFlag: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      gender: [
        {
          value: "男",
        },
        {
          value: "女",
        },
      ],
      month: MonthNum,
      day: DayNum,
      submitService: MerchantManage.listMerchantUserShH,
      params: {},
      page: {},
      isPage: false,
      flag: "",
      type: "",
      exportType: "",
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  created() {},
  mounted() {
    this.load();
    this.getTypeNames("chnName", (res) => {
      this.chnCode = [...this.chnCode, ...res];
    });
  },
  computed: {
    submitData() {
      if (this.time == null || this.time == "") {
        this.time = [];
      }
      const params = {
        realName: this.formModel.realName,
        merName: this.formModel.merName,
        merNo: this.formModel.merNo,
        merPhone: this.formModel.merPhone,
        agentNo: this.formModel.agentNo,
        chnCode: this.formModel.chnCode,
        gender: this.formModel.gender,
        birthday: this.formModel.month + this.formModel.day,
        weComFlag: this.formModel.weComFlag,
        isEvaluate: this.formModel.isEvaluate,
        terminalId: this.formModel.terminalId,

        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      if (this.textTatSimpleId) {
        params.tatSimpleId = this.formModel.tatSimpleId;
      }
      if (this.time.length) {
        params.startDate = this.time[0];
        params.endDate = this.time[1];
      }
      return params;
    },
    dialogData() {
      let params = {};
      let propName = this.type == 1 ? "id" : "merNo";
      switch (this.type) {
        case 1: //修改
          params = {
            actNum: this.dialogModel.actNum,
            merName: this.dialogModel.merName,
            terminalId: this.dialogModel.terminalId,
            merPhone: this.dialogModel.merPhone,
            realName: this.dialogModel.realName,
            idCardNo: this.dialogModel.idCardNo,
            ...{ [propName]: this.itemId },
          };
          break;
        case 2: //划拨
          params = {
            userId: this.dialogModel.userId,
            ...{ [propName]: this.itemId },
          };
          break;
        default:
          break;
      }
      return params;
    },
    dialogService() {
      let service = null;
      switch (this.type) {
        case 1: //修改
          service = OrganService.merchantInfoEdit;
          break;
        case 2: //划拨
          service = OrganService.merchantInfoHB;
          break;
        default:
          break;
      }
      return service;
    },
    ...mapGetters([
      "serverType",
      "tatId",
      "userId",
      "userInfo",
      "basicInfoFlag",
      "textTatSimpleId",
    ]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(vm.basicInfoFlag);
      if (
        from.path.indexOf("copymerchantInfoManage") > -1 &&
        vm.basicInfoFlag == true
      ) {
        vm.$refs.commonTopForm.submit();
      }
    });
  },
  methods: {
    load() {
      this.formModel = {
        chnCode: "",
        weComFlag: "",
        isEvaluate: "",
      };
  
       this.getList();
      this.getLevelNameList();
       this.getTypeTwo();
         this.page = this.$refs.commonTable.page;
    },
    getTypeTwo() {
      this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows, "res1");
            res.contents.rows.forEach((item) => {
              (item.dictValue = item.id), (item.dictKey = item.tatName);
            });
            this.typeTwo = [...this.typeTwo, ...res.contents.rows];
            console.log(this.tableData,'table')
            this.tableData.forEach(item => {
                  console.log(this.typeTwo,'itemTwo')
               this.typeTwo.forEach(itemTwo => {  

                 
                 if(item.tatId == itemTwo.dictValue) {
                   console.log('除非噶')
                   item.tatSimpleName = itemTwo.dictKey
                 } else if(!item.tatId) {
                   item.tatSimpleName = "--"
                 }
               })
             })
                this.getList();
          });

        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
        this.setBasicInfoFlag(false);
       this.tableData.forEach((item) => {
              this.typeTwo.forEach((itemTwo) => {
                if (item.tatId == itemTwo.dictValue) {
                  item.tatSimpleName = itemTwo.tatName;
                } else if (!item.tatId) {
                  item.tatSimpleName = "--";
                }
              });
            });
      });
    },
    handleDelete(item) {
      this.showConfirm("是否执行注销操作？")
        .then(() => {
          this.doDelete(item.merNo);
        })
        .catch(() => {});
    },
    doDelete(merNo) {
      this.doLoad(
        OrganService.merchantInfoZx,
        {
          merNo: merNo,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    openAddDialog(type, item) {
      this.type = type;
      this.itemId = item ? item.id : "";
      if (type == 1) {
        this.dialogModel = JSON.parse(JSON.stringify(item));
      }
      this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    dialogClose() {
      this.dialogModel = {
        actNum: undefined,
        merName: "",
        terminalId: "",
        merPhone: "",
        realName: "",
        idCardNo: "",

        userId: "",
      };
      this.type = "";
      this.itemId = "";
      this.memName = {};
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    down() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "exportMerchant",
            "8883",
            "/merchantinfo/t-merchant-info/"
          )
        : "";
    },
    implementIssuedcz(flag, type) {
      this.exportType = type;
      switch (flag) {
        case 1:
          this.centerDialogVisible = true;
          break;
        case 2:
          this.$refs.myForm.validate((valid) => {
            if (valid) {
              //校验成功
              this.centerDialogVisible = false;
              const url =
                this.exportType == 1
                  ? "exportForSleepList"
                  : "exportForTransactionList";
              const params =
                this.exportType == 1
                  ? {
                      startDate: this.form.startDate,
                    }
                  : {
                      date: this.form.date,
                    };
              this.limitExport(this.page.total)
                ? StatisticsService.exportExcel(
                    params,
                    url,
                    "8883",
                    "/merchantinfo/t-merchant-info/"
                  )
                : "";
            } else {
              //校验失败
              console.log("校验失败");
            }
          });

          break;
        default:
          break;
      }
    },
    startDateClose() {
      this.form.startDate = "";
    },
    click() {
      this.showConfirm("是否执行操作？")
        .then(() => {
          this.doup();
        })
        .catch(() => {});
    },
    doup() {
      this.doLoad(
        OrganService.merchantInfoup,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
        OrganService.merchantinfoStatus,
        {
          status: $event,
          id: scope.id,
          column: "enableWithdraw",
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusweComFlag($event, scope) {
      this.doweComFlag($event, scope);
    },
    doweComFlag($event, scope) {
      this.doLoad(
        OrganService.merchantinfoStatus,
        {
          status: $event,
          id: scope.id,
          column: "weComFlag",
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    getLevelNameList() {
      this.doLoad(
        OrganService.memberupgradeList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.levelNameList = result.rows;
          });
        },
        "信息获取失败"
      );
    },
    getRealNameByPhone(val, onSuccess) {
      const params = {
        tatSimpleId: this.tatId,
        userId: val,
      };
      this.doLoad(
        FinanceService.getRealNameByPhone,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    manage(row) {
      this.$router.push({
        name: "copymerchantInfoManage",
        params: {
          item: JSON.stringify(row),
        },
      });
    },
    feilv(row) {
      this.$router.push({
        name: "copymerchantInfoFeilv",
        params: {
          item: JSON.stringify(row),
        },
      });
    },
    ...mapActions({
      setBasicInfoFlag: StorageService.Reload.basicInfoFlag,
    }),
    formatterTableMemLevel(row, column, cellValue, index) {
      let value = "--";
      this.levelNameList.forEach((item) => {
        if (item.id == cellValue) {
          value = item.levelName;
        }
      });
      return value == "" ? "--" : value;
    },
    formatterTableDataChnCode(row, column, cellValue, index) {
      let value = "--";
      this.chnCode.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
p {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  margin-bottom: 30px;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 106px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.startDate {
  width: 300px;
  margin: auto;
}

/* .el-form-item__error {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 4px;
      padding-left: 50px;
      position: absolute;
      top: 100%;
      left: 0;
    } */
</style>



// WEBPACK FOOTER //
// src/view/page/MerchantManage/MerchantBind.vue